module.exports = __webpack_public_path__ + "img/cart4.2698e43d.svg";